import React, { PureComponent, Fragment } from 'react'
import { formatPrice } from 'helpers'
import moment from 'moment'
import cx from 'classnames'
import { connect } from 'redaction'

import { Grid, Cell } from 'components/layout/grid'
import Button from 'components/ui/Button/Button'
import Box from 'components/layout/Box/Box'

import Totals from './Totals/Totals'

import s from './LearningReport.scss'


const getTotals = ({ learnTotal, subscrTotal, schedTotal, total, name }) => {
  const result = []

  if (learnTotal) {
    result.push([
      'Итого (обучение):',
      '',
      learnTotal / 100
    ])
  }

  if (subscrTotal) {
    result.push([
      'Итого (абонементы):',
      '',
      subscrTotal / 100
    ])
  }

  if (schedTotal) {
    result.push([
      'Итого (разовые посещения):',
      '',
      schedTotal / 100
    ])
  }

  if (total) {
    result.push([
      `Итого ${name}:`,
      '',
      total / 100
    ])
  }

  return result
}


class LearningReport extends PureComponent {

  state = {
    node: null,
  }

  componentDidMount() {
    const { title } = this.props
    const encodedUri  = this.getEncodeUri()
    const link        = document.createElement('a')

    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `${title}.csv`)

    document.body.appendChild(link)

    this.setState({ node: link })
  }

  componentWillUnmount() {
    const { node } = this.state

    document.body.removeChild(node)
  }

  getEncodeUri = () => {
    const {
      title, headings, totals, toolsData, toolName,
    } = this.props

    let encodeData = 'data:text/csv;charset=utf-8,\uFEFF'

    const rows = []

    rows.push([ toolName ])
    rows.push([])

    rows.push([ title ])
    rows.push([])

    rows.push(headings)

    toolsData.forEach(({ name, totals, subscriptions }) => {
      rows.push([], [])
      rows.push([ name ])

      subscriptions.forEach((subscription) => {
        const row = []

        subscription.forEach((value) => {
          row.push(typeof value === 'object' ? value.price : value)
        })

        rows.push(row)
      })

      rows.push([])
      rows.push(...totals)
    })

    rows.push([], [])

    rows.push(...totals)

    rows.push([], [], [], [])

    rows.push([
      'Источник',
      'https://умныйсаров.рф/marketplace/admin/report',
    ])

    return `${encodeData}${
      rows.map((items) => (
        items.map((item) => String(item || '')).join(';')
      ))
        .join('\n')
      }`
  }

  handleButtonClick = () => {
    const { node } = this.state
    const { onClose } = this.props

    node.click()
    onClose()
  }

  render() {
    const {
      className, titleClassName, buttonClassName, darkClassName, darkestClassName,
      title, totals, toolsData, headings, toolName,
      isEmpty,
    } = this.props

    return (
      <div className={className}>
        <Box pb="24">
          <div className={titleClassName}>{toolName}</div>
        </Box>
        <Box pb="24">
          <div className={titleClassName}>{title}</div>
        </Box>
        {
          isEmpty ? (
            <div>Нет статистики по выбранным условиям</div>
          ) : (
            <Fragment>
              {
                toolsData.map(({ name, totals, subscriptions }, index) => (
                  <Box key={index} pb="24">
                    <Box pb="8" pt="8">{name}</Box>
                    {
                      Boolean(subscriptions.length) ? (
                        <Grid className={darkClassName} columns={headings.length} gutter="md">
                          {
                            headings.map((heading, index) => (
                              <Cell key={index} size={1}>
                                {heading}
                              </Cell>
                            ))
                          }
                        </Grid>
                      ) : (
                        <Grid columns={1} gutter="md">
                          <Cell size={1}>-</Cell>
                        </Grid>
                      )
                    }
                    {
                      subscriptions.map((subscription, index) => (
                        <Grid key={index} columns={subscription.length} gutter="md">
                          {
                            subscription.map((value, index) => (
                              <Cell key={index} size={1}>
                                {
                                  typeof value === 'object'
                                    ? value.formattedPrice
                                    : (
                                      <span dangerouslySetInnerHTML={{ __html: value }} />
                                    )
                                }
                              </Cell>
                            ))
                          }
                        </Grid>
                      ))
                    }
                    <Totals
                      totals={totals}
                    />
                  </Box>
                ))
              }
              <hr />
              <Box pt="24">
                <Totals
                  totals={totals}
                />
              </Box>
              <Box pt="24">
                <Button
                  className={buttonClassName}
                  title="Сохранить в файл"
                  green
                  onClick={this.handleButtonClick}
                />
              </Box>
            </Fragment>
          )
        }
      </div>
    )
  }
}


export default connect({
  title: (state, props) => {
    const { from, to, paymentType } = props

    const dateFrom  = moment(from, 'DDMMYYYY').format('DD.MM.YYYY')
    const dateTo    = moment(to, 'DDMMYYYY').format('DD.MM.YYYY')

    return `Справка о полученной выручке с портала умныйсаров.рф с ${dateFrom} по ${dateTo}`
  },
  headings: (state) => [
    'Номер заказа',
    'Проверочный код',
    'Сумма (руб.)',
    'Дата платежа',
    'Группа',
    'Тариф',
    'ФИО',
    'Дата рождения',
    '№ договора',
    'Оффлайн оплата'
  ],
  totals: (state, props) => {
    const { statistic: { total, learnTotal, subscrTotal, schedTotal } } = props

    return getTotals({ total, learnTotal, subscrTotal, schedTotal, name: 'все объекты' })
  },
  toolsData: (state, props) => {
    const { statistic: { tools } } = props

    return tools.map(({ total, learnTotal, schedTotal, subscrTotal, tool: { id, name }, subscriptions = [] }) => ({
      name,
      totals: getTotals({ total, learnTotal, subscrTotal, schedTotal, name }),
      subscriptions: subscriptions.map((subscription) => {
        const { id, subscriber, learnGroup, transaction, tariff, ts, voucher } = subscription

        const { birth, contractNum } = subscriber
        const { amount, offline } = transaction

        const fio         = Boolean(subscriber.firstName) && `${subscriber.lastName} ${subscriber.firstName} ${subscriber.middleName}`
        const paymentDate = `${moment(ts).format('DD.MM.YYYY')} ${moment(ts).format('HH:mm')}`
        const birthDate   = moment(birth, 'YYYY-MM-DD').format('DD.MM.YYYY')

        return [
          id,
          voucher,
          {
            price: Number(amount) / 100,
            formattedPrice: formatPrice(amount),
          },
          paymentDate,
          learnGroup.title,
          (tariff.description || '').replace(/"/g, '\'').replace(/;/g, ''),
          fio,
          birthDate,
          contractNum,
          offline ? 'Оффлайн' : '',
        ]
      }),
    }))
  },
  toolName: (state) => 'Обучение в группах',
})(LearningReport)
